import React from "react";
import NoFooterModal from "../../Common/NoFooterModal";
import { connect } from "react-redux";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";
import black from "sushiweb/tokens/color/black";
import Table from "../../Common/Table";
import TableFields from "../../../constants/FeatureConfig/VariantsTableFields.json";
import { getPath } from "../../../utils";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import BlankStateV2 from "../../Common/BlankStateV2";

const VariantsModal = (props) => {
  const { activeVariants, handleClose } = props;
  const allActions = MenuActionsMappings[MenuNames.FEATURE_CONFIG];

  const getFieldValue = (variant, key, index) => {
    switch (key) {
      case "number":
        return <p style={{ fontSize: "1rem" }}>{index}</p>;
      case "value":
        return typeof getPath(variant, "value", "-") === "object" ? (
          <div>
            <JSONInput
              id="jsonInput"
              placeholder={getPath(variant, "value", "-")}
              locale={locale}
              height="100px"
              width="auto"
              viewOnly={true}
              colors={{
                string: "#FA7921",
                number: "#50B547",
                background: "#00000000",
                keys: "#1E1E1E",
                default: black,
              }}
              confirmGood={false}
              theme="light_mitsuketa_tribute"
            />
          </div>
        ) : (
          <p style={{ fontSize: "1rem" }}>{getPath(variant, "value", "-")}</p>
        );
      case "conditions":
        return (
          <JSONInput
            id="jsonInput"
            placeholder={getPath(variant, "conditions", "-")}
            locale={locale}
            height="100px"
            width="auto"
            viewOnly={true}
            colors={{
              string: "#FA7921",
              number: "#0000FF",
              background: "#00000000",
              keys: "#1E1E1E",
              default: black,
            }}
            confirmGood={false}
            theme="light_mitsuketa_tribute"
          />
        );
    }
  };

  return (
    <NoFooterModal
      header={true}
      heading={`Variants`}
      handleClose={handleClose}
      id="VariantsModal"
    >
      <Table
        list={activeVariants}
        getFieldValue={getFieldValue}
        fields={TableFields}
        blankStateComponent={<BlankStateV2 heading={"No Variants"} />}
      />
    </NoFooterModal>
  );
};

export default connect()(VariantsModal);
